import React from "react";
import Container from "./components/Container/index";
import "./App.css";

function App() {
  return <Container />;
}

export default App;
